import _ from 'lodash';

import connect from 'components/lib/connect';
import UniversalSearchFilter from 'components/search/universal_search_filter';

const mapStateToProps = function ({ getProvider }, props) {
  const result = getProvider('universalSearchResults').findBy({ id: props.queryId });
  const aggregations = result ? result.aggregations : null;
  const documentType = result ? _.get(result, 'query.filter.type') : null;
  const documentTypes = result ? _.get(result, 'query.filter.types') : null;

  return {
    aggregations,
    documentType,
    documentTypes,
    hasResult: result ? !result.isLoading : false,
    onSearchFilterChange: props.onSearchFilterChange,
    queryId: props.queryId,
  };
};

export default connect(mapStateToProps)(UniversalSearchFilter);
